import PBService from "@irati/utils/services"
import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"

import {MutationBenefitsCreateEnquiryArgs, QueryBenefitsListBenefitsArgs} from "@irati/types"
import listBenefits, {listBenefitsKey} from "./queries/listBenefits"
import benefitsContent, {benefitsContentKey} from "./queries/benefitsContent"
import createEnquiry, {createEnquiryKey} from "./mutations/createEnquiry"

class Service extends PBService {
  benefitsListBenefits = (variables: QueryBenefitsListBenefitsArgs = {}, options: QueryOptions = {}) => {
    return client.query({...options, query: listBenefits, variables}).then(({data}) => {
      return data[listBenefitsKey]
    })
  }
  benefitsContent = (variables, options: QueryOptions = {}) => {
    return client.query({...options, query: benefitsContent, variables}).then(({data}) => {
      return data[benefitsContentKey]
    })
  }
  createEnquiry = (variables: MutationBenefitsCreateEnquiryArgs, options: MutationOptions = {}) => {
    return client.mutate({...options, mutation: createEnquiry, variables}).then(({data}) => {
      return data[createEnquiryKey]
    })
  }
}

const service = new Service({errorHandlers: []})

export default service
